const Category = "cocacola_map";

const GA_Event = (action, label) => {
    window.dataLayer.push({
        'event': 'GA_Event',
        'Category': Category,
        'Action': action,
        'Label': label
    });
}

export {
    GA_Event
}


// WEBPACK FOOTER //
// ./src/components/Analytics/Analytics.js